import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import Footer from 'components/Footer';
import { rem } from 'polished';
import { COLOR, SPACE } from 'config';

import Hero from './components/Hero';
import Content from './components/Content';
import Secure from './components/Secure';
import Accessible from './components/Accessible';
import LearnMore from './components/LearnMore';
import WatchAndLearn from './components/WatchAndLearn';
import headerBackground from './images/header.png';

const LandingContainer = styled.div`
  background-color: ${COLOR.lightGrey};
`;

const MobileWalletsLanding = ({ intl }) => (
  <LandingContainer>
    <Helmet>
      <meta
        name="description"
        content={intl.formatMessage({ id: 'landing.mobileWallets.description' })}
      />
    </Helmet>
    <Hero
      title="landing.mobileWallets.hero.title"
      description="landing.mobileWallets.hero.heading1"
      description2="landing.mobileWallets.hero.heading2"
      buttonText="landing.mobileWallets.hero.button"
      to="https://www.skycoin.com/downloads/"
      banner={headerBackground}
    />
    <Content mb={rem(SPACE[3])} mx="auto" notHero>
      <Accessible />
      <WatchAndLearn />
      <Secure />
      <LearnMore />
    </Content>
    <Footer />
  </LandingContainer>
);

MobileWalletsLanding.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(MobileWalletsLanding);



// WEBPACK FOOTER //
// ./src/components/MobileWalletsLanding/MobileWalletsLanding.js